import { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { useLang } from "@/lib/lang";
import { Reveal, Eyebrow } from "./Reveal";

export const Process = () => {
  const { t } = useLang();
  const p = t.process;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 60%"] });
  const scaleY = useSpring(scrollYProgress, { stiffness: 80, damping: 20 });

  return (
    <section id="proces" className="section bg-surface" data-testid="process-section">
      <div className="container-x">
        <Reveal><Eyebrow>{p.eyebrow}</Eyebrow></Reveal>
        <Reveal delay={0.05}><h2 className="h2 mt-6 max-w-3xl">{p.title}</h2></Reveal>
        <div ref={ref} className="relative mt-16 pl-8 sm:pl-14">
          <div className="absolute bottom-0 left-0 top-0 w-px bg-line" />
          <motion.div style={{ scaleY }} className="absolute bottom-0 left-0 top-0 w-px origin-top bg-gold" />
          {p.steps.map((s, i) => (
            <Reveal key={s.t} className="group relative grid gap-4 border-b border-line py-10 last:border-b-0 md:grid-cols-12 md:gap-8" >
              <span className="absolute -left-8 top-12 h-3 w-3 -translate-x-1/2 rounded-full border border-gold bg-bg transition-colors duration-500 group-hover:bg-gold sm:-left-14" />
              <span className="font-display text-6xl font-semibold leading-none text-transparent [-webkit-text-stroke:1px_rgba(242,240,234,0.35)] transition-colors duration-500 group-hover:text-gold md:col-span-2 md:text-7xl" data-testid={`process-step-num-${i}`}>0{i + 1}</span>
              <h3 className="font-display text-2xl font-medium text-ink md:col-span-4 md:text-3xl" data-testid={`process-step-title-${i}`}>{s.t}</h3>
              <p className="text-zinc-300 md:col-span-6">{s.d}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
